import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';

type Props = {
  applied: boolean;
  onMarkAsApplied: () => Promise<void>;
  onMarkAsNotApplied: () => Promise<void>;
  className?: string;
};

export function ListingActionsDropdownMarkApplied({
  applied,
  onMarkAsApplied,
  onMarkAsNotApplied,
  className,
}: Props) {
  const { i18n } = useI18n();

  if (applied) {
    return (
      <Button
        type="button"
        qaId="mark-not-applied-button"
        variant="tertiary-grey"
        onClick={() => {
          void onMarkAsNotApplied();
        }}
        className={className}
        size="small"
      >
        {i18n('Mark As Not Applied')}
      </Button>
    );
  }

  return (
    <Button
      type="button"
      qaId="mark-applied-button"
      variant="tertiary-grey"
      onClick={() => {
        void onMarkAsApplied();
      }}
      className={className}
      size="small"
      icon={{ type: 'normalized', name: 'simple-check' }}
    >
      {i18n('Mark As Applied')}
    </Button>
  );
}
